import { render } from "./dashboard.vue?vue&type=template&id=1d16989e&scoped=true"
import script from "./dashboard.js?vue&type=script&lang=js"
export * from "./dashboard.js?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=1d16989e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d16989e"]])

export default __exports__